import React from 'react'
import UserWhiteSvg from '../../../assets/icons/UserWhiteSvg'
import CalendarBlackSvg from '../../../assets/icons/CalendarBlackSvg'
import { Collapse } from 'reactstrap'
import './HistoryItem.css'

const HistoryItem = ({ item }) => {
  return (
    <div key={item.id}>
      <div className='rezervasyon-item'>
        <div style={{ display: 'flex', gap: '.5rem' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: item.title === 'Giriş' ? 'radial-gradient(#C6E9DA, #7EC2A5)' : 'radial-gradient(rgb(248 200 200), rgb(236 146 146))',
              padding: '.8rem',
              borderRadius: '100%',
            }}
          >
            <UserWhiteSvg width={'.9rem'} />
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'start',
              justifyContent: 'center',
              margin: '0 0 0 .4rem',
              lineHeight: '1.3',
            }}
          >
            <div style={{ fontWeight: '500' }}>{item.title}</div>
            <div>{item.guest_name}</div>
          </div>
        </div>
        <div style={{ display: 'flex', gap: '.5rem' }}>
          <CalendarBlackSvg width={'.9rem'} />
          <div>{item.date}</div>
        </div>
      </div>
      <Collapse style={{ margin: '1rem 0 0 0' }}>
        <div style={{ border: '1px solid #F3F3F3' }}>
          <div className='clp-list-item1'>
            <div style={{ margin: '0 0 0 .7rem', fontWeight: 'bold' }}>Tarih: </div>
            <div style={{ margin: '0 0 0 .3rem' }}>{item.date}</div>
          </div>
          <div className='clp-list-item2'>
            <div style={{ margin: '0 0 0 .7rem', fontWeight: 'bold' }}>Misafir Türü: </div>
            <div style={{ margin: '0 0 0 .3rem' }}>{item.misafir_turu}</div>
          </div>
          {/* <div className='clp-list-item1'>
            <div style={{ margin: '0 0 0 .7rem', fontWeight: 'bold' }}>
              Misafir Sayısı:{' '}
            </div>
            <div style={{ margin: '0 0 0 .3rem' }}>{item.guest_count}</div>
          </div>
          <div className='clp-list-item2'>
            <div style={{ margin: '0 0 0 .7rem', fontWeight: 'bold' }}>
              Plaka:{' '}
            </div>
            <div style={{ margin: '0 .8rem 0 .3rem' }}>{item.number_plate}</div>
          </div> */}
        </div>
      </Collapse>
    </div>
  )
}

export default HistoryItem
